/**
 * C3 — decisão de entrada pós-login (multi-unidade). Não depende de nada.
 *
 * Regra portada de `clinic_selection_page.dart`: sem unidade vinculada o usuário precisa criar;
 * com unidades vinculadas e sem ativa resolvível ele escolhe; caso contrário o app entra direto.
 * Testável sem Vue e sem HTTP.
 */

export type CompanyEntryDecision =
  /** Unidade ativa resolvida — o shell pode entrar direto. */
  | { readonly kind: 'ready'; readonly companyId: string }
  /** Há unidades, mas nenhuma está ativa/resolvível — exige escolha. */
  | { readonly kind: 'choose' }
  /** Nenhuma unidade vinculada — exige criação (ou convite aceito por e-mail). */
  | { readonly kind: 'create' };

export function companyEntryDecision(
  companyIds: readonly string[],
  activeCompanyId: string | undefined,
): CompanyEntryDecision {
  if (companyIds.length === 0) return { kind: 'create' };
  if (activeCompanyId !== undefined && companyIds.includes(activeCompanyId)) {
    return { kind: 'ready', companyId: activeCompanyId };
  }
  const first = companyIds[0];
  if (companyIds.length === 1 && first !== undefined) {
    return { kind: 'ready', companyId: first };
  }
  return { kind: 'choose' };
}
